import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MatSidenav } from '@angular/material';

@Injectable()
export class NavService {
  public appDrawer: MatSidenav;
  public currentUrl = new BehaviorSubject<string>(undefined);

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }

  public setSidenav(sidenav: MatSidenav) {
    this.appDrawer = sidenav;
  }

  public closeNav() {
    if (this.appDrawer) {
      this.appDrawer.close();
    }
  }

  public openNav() {
    this.appDrawer.open();
  }

  public toggle(): void {
    this.appDrawer.toggle();
  }
}
